const houseSelectorEvents = {
    POLYGON_HOVER: 'house-selector::polygonHovered',
    POLYGON_FOCUS: 'house-selector::focusPolygon',
};

export { houseSelectorEvents };
